import * as proto from 'src/proto/compiled-protos';
import { Util } from "src/app/general/util/util";
import { ToolbarAction } from "src/app/general/components/toolbar/toolbar-action";
import { ProtoType } from "../util/constants";
import { SessionService } from "../services/session.service";
import { ToolbarUtil } from "../util/toolbar-util";

export class RemoteLogToolbarModel {
  sessionService: SessionService;

  public actions: Array<ToolbarAction<proto.waiternow.common.IRemoteLogProto>>;
  public compactActions: Array<ToolbarAction<proto.waiternow.common.IRemoteLogProto>>;

  constructor(
      sessionService: SessionService) {
    this.sessionService = sessionService;

    this.actions =
    [
      ToolbarUtil.createToolbarActionViewProto(ProtoType.REMOTE_LOG, remoteLog => Util.safeString(remoteLog.id), this.sessionService)
    ];

    this.compactActions = this.actions;
  }
}
